module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/1_fa9baab23f72d712a06a8d444821a5a4.png";